


































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import requestService from "@/service/requestService";
import PaymentService from "@/service/paymentService";
import Number from "@/shared/filters/Number";
import { Utils } from "@/service/util";
import { CouponData, CouponItem } from "@/model/Coupon";
import { Getter, Action } from "vuex-class";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { UserService } from "@/service/UserService";
import UserFooter from "@/components/UserFooter.vue";
import { MESSAGE } from "@/model/Message";
import TopBarTitle from "@/components/common/TopBarTitle.vue";
import InputNumber from "@/components/common/input/InputNumber.vue";
@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    UserFooter,
    TopBarTitle,
    InputNumber
  }
})
export default class CouponPage extends Vue {
  public utils: Utils = new Utils();
  isModeModal: boolean = false;
  isModeQuick: boolean = false;
  excludingFlg: boolean = false;
  excludingTex: string = "";

  isEditPrice: boolean = false;
  showAside: boolean = true;
  reqService: requestService;
  pmtService: PaymentService;
  couponResult: any = 0;
  // couponData: CouponData = {
  //   coupon: {},
  //   proposal: {}
  // };
  subTotalZk: number = 0;
  subTotalZn: number = 0;

  updating: boolean = false;
  loadingText: string = MESSAGE.Loading;

  couponNm: string = "";
  couponZk: number | null = null;
  /** 2023-10-26 invoice [START] */
  couponZn: number | null = null;
  /** 2023-10-26 invoice [END] */

  totalAllZn: number = 0;
  totalAllZk: number = 0;
  totalACalcZk: number = 0;

  demandWarn: boolean = false;
  demandAllZk: number | null = null;
  demandAnswerZk: number = 0;

  $refs!: {
    // confirmDialog: ConfirmDialog;
    errorDialog: ConfirmDialog;
    waitmd15Dialog: ConfirmDialog;
    inputKingaku: InputNumber[];
    exceedDialog: ConfirmDialog;
  };

  @Action("setCoupon", { namespace: "Coupon" })
  setCoupon: any;
  @Action("confirm", { namespace: "Coupon" })
  confirm: any;
  @Action("autoSave", { namespace: "Coupon" })
  autoSave: any;

  @Getter("hasData", { namespace: "Coupon" })
  hasData: boolean;
  @Getter("currentState", { namespace: "Coupon" })
  couponData: CouponData;
  @Getter("currentState", { namespace: "Coupon" })
  couponDataForSave: CouponData;
  @Getter("hasTokuten", { namespace: "Coupon" })
  hasTokuten: boolean;
  @Getter("hasProposal", { namespace: "Coupon" })
  hasProposal: boolean;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("couponLoading", { namespace: "UserDataState" })
  isLoading: boolean;
  @Getter("couponError", { namespace: "UserDataState" })
  couponError: string;
  @Action("setError", { namespace: "UserDataState" })
  setError: any;

  @Getter("waitPartsSelect", { namespace: "SubHeader" })
  waitPartsSelect: boolean;

  @Action("updateSubTotal", { namespace: "Coupon" })
  updateSubTotal: any;

  /** 2021-05-31 sh #7126 fix add manual input [START] */
  @Getter("isConfirm", { namespace: "Coupon" })
  isConfirmCoupon: any;
  @Getter("couponLimitZn", { namespace: "Coupon" })
  couponLimitZn: any;
  @Getter("couponLimitZk", { namespace: "Coupon" })
  couponLimitZk: any;
  /** 2021-05-31 sh #7126 fix add manual input [END] */
  @Getter("waitingAutoSave", { namespace: "Coupon" })
  waitingAutoSave: any;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  @Getter("couponLabel", { namespace: "FunctionSetting" })
  couponLabel: string;
  /** 2023-10-19 invoice [END] */
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  isPopupExceed: boolean = false; // 1回警告を出したら2回目以降は出さないようにするためのフラグ

  get msgExceed() {
    return this.couponLabel + "の上限金額を超えています。";
  }

  get isError() {
    return this.couponError != "";
  }

  onCloseError() {
    this.setError({ key: "coupon", value: "" });
  }

  created() {
    if (window.sessionStorage.getItem("shaken:v2:user:coupon-edit-mode")) {
      this.isEditPrice = true;
      window.sessionStorage.removeItem("shaken:v2:user:coupon-edit-mode");
    }
    this.getCoupon();
  }

  mounted() {
    // if (this.$refs.sideTab) {
    //  this.$refs.sideTab.onActive(1);
    // }
    this.$emit("onActiveSideTab", "discountcoupon");
  }

  getCoupon() {
    this.reqService = new requestService();
    this.pmtService = new PaymentService();

    if (!this.hasData && !this.isLoading) {
      const userService = new UserService();
      userService.getAllData();
      setTimeout(() => {
        this.onCheckChange();
      }, 750);
      // get data from api
      // this.reqService
      //   .getCoupon(this.uketsukeExtendsId)
      //   .then((response: any) => {
      //     if (response && response.coupon && response.proposal) {
      //       this.setCoupon(response);
      //       this.$set(this, "couponData", { ...response });
      //       this.mapIsCheck();
      //     }
      //   });
    } else {
      this.onCheckChange();
    }
  }

  // onConfirm() {
  //   this.$refs.confirmDialog.onOpen();
  // }

  onConfirm(isConfirm: number) {
    if (this.couponData) {
      if (this.couponData.coupon && this.couponData.coupon.items) {
        this.couponData.coupon.subTotalZk = this.subTotalZk;
        this.couponData.coupon.subTotalZn = this.subTotalZn;
      }
      this.setCoupon(this.couponData);
      let isConfirmCopied: any = isConfirm;
      if (isConfirm == 0) {
        isConfirmCopied = this.couponData.isConfirm;
      }
      if (
        this.couponDataForSave.coupon &&
        this.couponDataForSave.proposal &&
        this.couponDataForSave.tokuten
      ) {
        this.$set(this, "updating", true);
        const savePromise = this.reqService
          .saveCoupon({ // sendSocket:ソケット仮11
            coupons: this.couponDataForSave.coupon.items || [],
            proposals: this.couponDataForSave.proposal.items || [],
            tokutens: this.couponDataForSave.tokuten.items || [],
            sknUketsukeUserJouhou: {
              isConfirmCoupon: isConfirmCopied
            },
            sknUketsukeExtendsId: this.uketsukeExtendsId
          })
          .then(
            (res: any) => {
              this.$set(this, "updating", false);
              this.autoSave(0);
              if (isConfirm == 1) {
                if ( this.isNextageCustom ) {
                  this.$router.push({ name: "userlegal56Nex1" });
                } else if (this.waitPartsSelect) {
                  this.$refs.waitmd15Dialog.onOpen();
                } else {
                  this.$router.push({ name: "userlegal56" });
                }
                /** 2021-06-01 sh #7123 if change checkbox, it gets flag from server. [START] */
                // this.confirm(isConfirmCopied);
                // this.$emit("onUserConfirm");
                this.$emit("onUserConfirmSync");
                /** 2021-06-01 sh #7123 if change checkbox, it gets flag from server. [END] */
              }
            },
            (error: any) => {
              this.$set(this, "updating", false);
              this.$notify.error({
                title: "エラー",
                message: MESSAGE.SystemError
              });
            }
          );
        // 保存処理中に赤画面の右サイドバーを無効化するため、親画面にPromiseを渡す
        // FIXME: 直観的でないので改善したい。
        //        単純に「保存処理の前後にemit」だと、右サイドバークリックイベントの場合に処理中に別のページに切り替わり、処理後のemitが親画面に届かずボタンが無効のままとなった。
        this.$emit("onOptionCouponUpdating", savePromise);

      } else {
        this.autoSave(0);
        this.confirm(isConfirmCopied);
        this.$emit("onUserConfirm");
      }
    } else {
      this.autoSave(0);
      if (isConfirm == 1) {
        if ( this.isNextageCustom ) {
          this.$router.push({ name: "userlegal56Nex1" });
        } else if (this.waitPartsSelect) {
          this.$refs.waitmd15Dialog.onOpen();
        } else {
          this.$router.push({ name: "userlegal56" });
        }
      }
    }
  }

  onSave() {
    this.onConfirm(0);
  }

  get sum() { // 税込みの合算
    this.totalCalc();
    if ( this.isExcludingTax ) {
      return this.totalACalcZk;
    } else {
      return this.totalAllZk;
    }
  }

  totalCalc() {
    const promise = this.pmtService.setTotalCalc();
    Promise.all([promise]).then(() => {
      const state = this.pmtService.getTotalCalc();
      this.totalAllZn = state.totalSumZn;
      this.totalAllZk = state.totalSumZk;
      this.totalACalcZk = state.totalCalcZk;
    });

    if (this.demandAnswerZk == 0) {
     this.demandCalcAnswer(); 
    } else if (this.couponZn == null || this.couponZn == 0) {
      this.demandAnswerZk = this.isExcludingTax? this.totalACalcZk: this.totalAllZk;
    }
  }


@Watch("couponZn")
  demandCalcAnswer() {
    let num = this.couponZn != null ? this.couponZn: 0;
  //  console.log(num);
    const promise2 = this.pmtService.setDemandAnswerNex(num);
    Promise.all([promise2]).then(() => {
      this.demandAnswerZk = this.pmtService.getDemandAnswerNex();
      // this.totalBaseZn = state.totalSumZn;
      // this.totalBaseZk = state.totalSumZk;
      // this.totalBCalcZk = state.totalCalcZk;
    });
  }

  demandCalc() {

    let demand = this.demandAllZk == null? 0: this.demandAllZk;
    let total = this.isExcludingTax? this.totalACalcZk : this.totalAllZk;

    // 有効値の判断
    if ( total < demand ) {
      this.demandWarn = true;
      this.couponZn = null;
    } else {
      this.demandWarn = false;
      if (this.isExcludingTax) {
        this.reqService.getZeinuki( total - demand ).then(
          (response: any) => {
            if (response) {
              this.couponZn = -1 * response.priceZn;
              // this.setDemandCalc( ( this.totalACalcZk < num ) , response.priceZn );
            }
          },
          (err: any) => {  }
        );
      } else {
        this.couponZn = -1 * ( total - demand );
        // this.setDemandCalc( ( this.totalAllZk < num ) , this.totalAllZk - num );
      }
    }
    // this.couponZn = -1 * num;
  }

  setDemandCalc( judge: boolean, num: number ) {
    if ( judge ) {
      this.demandWarn = true;
      this.couponZn = 0;
    } else {
      this.demandWarn = false;
      this.couponZn = -1 * num;
    }
    
  }

  calcTotal() {
    let tempSubTotalZk: number = 0;
    let tempSubTotalZn: number = 0;
    if (this.couponData.coupon && this.couponData.coupon.items) {
      this.couponData.coupon.items.filter(data => {
        if (data.isCheck == 1) {
          tempSubTotalZk += data.couponZk ? data.couponZk : 0;
          tempSubTotalZn += data.couponZn ? data.couponZn : 0;
        }
      });
      this.subTotalZk = tempSubTotalZk;
      this.subTotalZn = tempSubTotalZn;
    }
  }

  onCheck(value: any, item: any) {
    item.isCheck = value ? 1 : 0;
  }

  gotoCustomer() {
    this.$router.push({
      name: "usercustomer",
      params: { code: this.yoyakuNo }
    });
  }

  onCheckChange(coupon?: any) {
    this.calcTotal();
    this.updateSubTotal({
      subTotalZk: this.subTotalZk,
      subTotalZn: this.subTotalZn
    });

    if (coupon && coupon.isCheck && !this.isPopupExceed) {
      if (this.couponLimitZn) {
        if (Math.abs(this.subTotalZn) > Math.abs(this.couponLimitZn)) {
          this.$refs.exceedDialog.onOpen();
          this.isPopupExceed = true;
        }
      }
    }
  }

  focusNext(index: number) {
    if (this.$refs.inputKingaku[index + 1]) {
      this.$refs.inputKingaku[index + 1].focus();
    }
  }

  beforeDestroy() {
    if (this.isEditPrice) {
      window.sessionStorage.setItem("shaken:v2:user:coupon-edit-mode", "1");
    } else {
      window.sessionStorage.removeItem("shaken:v2:user:coupon-edit-mode");
    }
  }

  onOKWaitmd15Dialog() {
    this.$router.push({ name: "statusresult" });
  }

  onClickEdit(isEdit: boolean) {
    this.isEditPrice = isEdit;
    if (!this.isEditPrice) {
      this.onConfirm(0);
      this.onCheckChange(); // 小計金額更新
    }
  }

  onChangeKingaku() {
    /** 2023-10-26 invoice [Start] */
    if (this.couponZn && this.couponZn > 0) {
      this.couponZn = this.couponZn * -1;
    }
    /** 2023-10-26 invoice [End] */
    if (this.couponZk && this.couponZk > 0) {
      this.couponZk = this.couponZk * -1;
    }
  }
  addWork() {
    if (this.couponNm) {
      let item: CouponItem = {
        num: 0
        , couponNm: this.couponNm
        , couponZk: this.couponZk ? this.couponZk: 0
        /** 2023-10-26 invoice [START] */
        , couponZn: this.couponZn ? this.couponZn: 0
        /** 2023-10-26 invoice [END] */
        , isCheck: 0
      };
      if (this.couponData) {
        if (this.couponData.coupon) {
          if (this.couponData.coupon.items) {
            item.num = this.couponData.coupon.items.length + 1;
            this.couponData.coupon.items.push(item);
          } else {
            let items = [];
            items.push(item);
            this.couponData.coupon.items = items;
          }
        } else {
            let items = [];
            items.push(item);
            let coupon = {
              items: items
            };
          this.couponData.coupon = coupon;
        }
      } else {
        let items = [];
        items.push(item);
        let coupon = {
          items: items
        };
        this.couponData = {
          coupon: coupon
        };
      }
      this.couponNm = "";
      this.couponZk = null;
      /** 2023-10-26 invoice [START] */
      this.couponZn = null;
      /** 2023-10-26 invoice [END] */
    }

    this.autoSave(1);
  }

  /** 2021-05-31 sh #7126 fix add manual input [START] */
  onChangeCoupon(coupon?: any) {
    /** 一度確認を押した後、内容が変更になったら、未にする */
    if (this.isConfirmCoupon == 1) {
      const couponCurrent = JSON.stringify(this.couponDataForSave.coupon);
      const couponOld = JSON.stringify(this.couponDataForSave.couponOld);
      if (couponCurrent != couponOld) {
        this.confirm(0);
        this.$emit("onUserConfirm");
      }
    }
    this.onCheckChange(coupon);
  }

  // 別画面移動時の自動保存を有効化
  setAutoSave() {
    this.autoSave(1);
  }

  get checkManualCoupon() {
    /** 2023-10-26 invoice [Start] */
    if (this.couponNm && ( this.couponZn || this.couponZk ) ) {
    /** 2023-10-26 invoice [End] */
      return false;
    }
    return true;
  }
  /** 2021-05-31 sh #7126 fix add manual input [END] */
}
